import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-collaborateur',
  templateUrl: './home-collaborateur.component.html',
  styleUrls: ['./home-collaborateur.component.css']
})
export class HomeCollaborateurComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home-collaborateur/home-collaborateur.component.ts